<template>
  <div class="login-page">
    <!-- 背景装饰 -->
    <div class="bg-decoration">
      <!-- 呼吸粒子 -->
      <div class="particles">
        <span class="particle p1"></span>
        <span class="particle p2"></span>
        <span class="particle p3"></span>
        <span class="particle p4"></span>
        <span class="particle p5"></span>
        <span class="particle p6"></span>
        <span class="particle p7"></span>
        <span class="particle p8"></span>
        <span class="particle p9"></span>
        <span class="particle p10"></span>
        <span class="particle p11"></span>
        <span class="particle p12"></span>
        <span class="particle p13"></span>
        <span class="particle p14"></span>
        <span class="particle p15"></span>
        <span class="particle p16"></span>
      </div>

      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="floating-icon icon-1">
        <i class="el-icon-truck"></i>
      </div>
      <div class="floating-icon icon-2">
        <i class="el-icon-s-promotion"></i>
      </div>
      <div class="floating-icon icon-3">
        <i class="el-icon-location-outline"></i>
      </div>
    </div>

    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- 左侧品牌区域 -->
      <div class="brand-section">
        <div class="brand-content">
          <div class="logo-wrapper">
            <div class="logo-icon">JHT</div>
          </div>
          <h1 class="brand-title">
            <span class="title-char">捷</span><span class="title-char">惠</span><span class="title-char">通</span><span class="title-char">流</span><span class="title-char">易</span>
          </h1>
          <p class="brand-subtitle">JieHuiTong Logistics</p>
          <div class="brand-features">
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>高效便捷</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>专业服务</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>安全可靠</span>
            </div>
          </div>
        </div>
        <div class="brand-decoration">
          <div class="deco-line"></div>
          <div class="deco-line"></div>
          <div class="deco-line"></div>
        </div>
      </div>

      <!-- 右侧表单区域 -->
      <div class="form-section">
        <div class="form-wrapper">
          <div class="form-header">
            <div class="form-title">
              <span>欢</span><span>迎</span><span>登</span><span>录</span>
            </div>
            <p class="form-desc">请输入您的账号信息</p>
          </div>

          <el-form
            :model="loginForm"
            :rules="rules"
            ref="loginForm"
            class="login-form"
          >
            <el-form-item prop="username">
              <div class="input-wrapper">
                <div class="input-icon">
                  <i class="el-icon-user"></i>
                </div>
                <el-input
                  v-model="loginForm.username"
                  placeholder="请输入账号"
                  prefix-icon=""
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="password">
              <div class="input-wrapper">
                <div class="input-icon">
                  <i class="el-icon-lock"></i>
                </div>
                <el-input
                  v-model="loginForm.password"
                  type="password"
                  placeholder="请输入密码"
                  show-password
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item>
              <el-checkbox v-model="rememberMe" class="remember-checkbox">记住密码</el-checkbox>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                class="login-btn"
                :loading="loading"
                @click="handleLogin"
              >
                登 录
              </el-button>
            </el-form-item>
          </el-form>

          <div class="form-footer">
            <p class="company-name">乌鲁木齐捷惠通国际物流有限公司</p>
            <p class="company-name">新ICP备2026003784号-1</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/api";

export default {
  name: "LoginPage",
  data() {
    return {
      loading: false,
      rememberMe: false,
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    const savedUsername = localStorage.getItem("rememberedUsername");
    const savedPassword = localStorage.getItem("rememberedPassword");
    if (savedUsername && savedPassword) {
      this.loginForm.username = savedUsername;
      this.loginForm.password = savedPassword;
      this.rememberMe = true;
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const res = await login(this.loginForm);
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("createUser", res.data.user.name);

          // 记住密码
          if (this.rememberMe) {
            localStorage.setItem("rememberedUsername", this.loginForm.username);
            localStorage.setItem("rememberedPassword", this.loginForm.password);
          } else {
            localStorage.removeItem("rememberedUsername");
            localStorage.removeItem("rememberedPassword");
          }

          this.$router.replace({ path: "/home" });
        } catch (error) {
          console.log("登录失败:", error);
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;

  .circle {
    position: absolute;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(3, 169, 244, 0.1), rgba(3, 169, 244, 0.05));
    animation: float 6s ease-in-out infinite;

    &.circle-1 {
      width: 400px;
      height: 400px;
      top: -100px;
      right: -100px;
      animation-delay: 0s;
    }

    &.circle-2 {
      width: 300px;
      height: 300px;
      bottom: -50px;
      left: -50px;
      animation-delay: 2s;
    }

    &.circle-3 {
      width: 200px;
      height: 200px;
      top: 50%;
      left: 10%;
      animation-delay: 4s;
    }
  }

  .floating-icon {
    position: absolute;
    font-size: 40px;
    color: rgba(3, 169, 244, 0.15);
    animation: floatIcon 8s ease-in-out infinite;

    &.icon-1 {
      top: 15%;
      left: 8%;
      animation-delay: 0s;
    }

    &.icon-2 {
      top: 70%;
      right: 15%;
      animation-delay: 3s;
    }

    &.icon-3 {
      bottom: 20%;
      left: 20%;
      animation-delay: 5s;
    }
  }

  .particles {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .particle {
      position: absolute;
      width: 24px;
      height: 24px;
      background: #57a9f2;
      border-radius: 50%;
      opacity: 0;
      animation: breathe 4s ease-in-out infinite;

      &.p1 { top: 10%; left: 15%; animation-duration: 3s; }
      &.p2 { top: 20%; left: 85%; animation-duration: 4s; animation-delay: 0.5s; }
      &.p3 { top: 35%; left: 25%; animation-duration: 3.5s; animation-delay: 1s; }
      &.p4 { top: 45%; left: 75%; animation-duration: 4.5s; animation-delay: 0.3s; }
      &.p5 { top: 55%; left: 40%; animation-duration: 3.2s; animation-delay: 1.5s; }
      &.p6 { top: 65%; left: 60%; animation-duration: 4.2s; animation-delay: 0.8s; }
      &.p7 { top: 75%; left: 20%; animation-duration: 3.8s; animation-delay: 2s; }
      &.p8 { top: 80%; left: 90%; animation-duration: 4.8s; animation-delay: 0.2s; }
      &.p9 { top: 15%; left: 55%; animation-duration: 3.3s; animation-delay: 1.2s; }
      &.p10 { top: 25%; left: 5%; animation-duration: 4.3s; animation-delay: 0.7s; }
      &.p11 { top: 50%; left: 95%; animation-duration: 3.7s; animation-delay: 1.8s; }
      &.p12 { top: 85%; left: 35%; animation-duration: 4.7s; animation-delay: 0.4s; }
      &.p13 { top: 5%; left: 70%; animation-duration: 3.6s; animation-delay: 2.2s; }
      &.p14 { top: 60%; left: 10%; animation-duration: 4.4s; animation-delay: 0.9s; }
      &.p15 { top: 40%; left: 50%; animation-duration: 3.9s; animation-delay: 1.6s; }
      &.p16 { top: 90%; left: 65%; animation-duration: 4.1s; animation-delay: 0.1s; }
    }
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}

@keyframes floatIcon {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

@keyframes breathe {
  0%, 100% {
    opacity: 0;
    transform: scale(0.5);
    box-shadow: 0 0 0 0 rgba(87, 169, 242, 0.4);
  }
  50% {
    opacity: 0.8;
    transform: scale(1);
    box-shadow: 0 0 20px 10px rgba(87, 169, 242, 0.1);
  }
}

.login-card {
  display: flex;
  width: 900px;
  height: 560px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 1;
}

.brand-section {
  width: 45%;
  background: linear-gradient(135deg, #0288d1 0%, #03a9f4 100%);
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  .brand-content {
    position: relative;
    z-index: 2;

    .logo-wrapper {
      margin-bottom: 30px;

      .logo-icon {
        display: inline-block;
        background: rgba(255, 255, 255, 0.2);
        padding: 12px 20px;
        border-radius: 12px;
        font-size: 24px;
        font-weight: bold;
        color: #fff;
        backdrop-filter: blur(10px);
        font-style:oblique;
      }
    }

    .brand-title {
      font-size: 40px;
      font-weight: bold;
      color: #fff;
      margin: 0 0 10px 0;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
      display: flex;
      gap: 8px;
      font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;

      .title-char {
        display: inline-block;
        font-family: "阿里巴巴普惠体", "Alibaba PuHuiTi", "PingFang SC", sans-serif;
        animation: charFloat 3s ease-in-out infinite;

        &:nth-child(1) { animation-delay: 0s; }
        &:nth-child(2) { animation-delay: 0.15s; }
        &:nth-child(3) { animation-delay: 0.3s; }
        &:nth-child(4) { animation-delay: 0.45s; }
        &:nth-child(5) { animation-delay: 0.6s; }
      }
    }

    @keyframes charFloat {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-5px);
      }
    }

    .brand-subtitle {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      margin: 0 0 40px 0;
      letter-spacing: 2px;
    }

    .brand-features {
      .feature-item {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #fff;
        margin-bottom: 15px;
        font-size: 16px;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        animation: fadeInUp 0.5s ease-out forwards;
        opacity: 0;
        animation-fill-mode: forwards;

        &:nth-child(1) { animation-delay: 0.3s; }
        &:nth-child(2) { animation-delay: 0.5s; }
        &:nth-child(3) { animation-delay: 0.7s; }

        i {
          width: 26px;
          height: 26px;
          background: rgba(255, 255, 255, 0.25);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          animation: pulse 2s ease-in-out infinite;
          animation-delay: inherit;

          &:nth-child(1) { animation-delay: 0.3s; }
          &:nth-child(2) { animation-delay: 0.5s; }
          &:nth-child(3) { animation-delay: 0.7s; }
        }

        span {
          position: relative;

          &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 0;
            height: 2px;
            background: rgba(255, 255, 255, 0.6);
            transition: width 0.3s ease;
          }

          &:hover::after {
            width: 100%;
          }
        }
      }
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      background: rgba(255, 255, 255, 0.25);
    }
    50% {
      transform: scale(1.1);
      background: rgba(255, 255, 255, 0.35);
    }
  }

  .brand-decoration {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    padding-right: 20px;

    .deco-line {
      width: 60px;
      height: 4px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 2px;

      &:nth-child(2) {
        width: 40px;
      }

      &:nth-child(3) {
        width: 80px;
      }
    }
  }
}

.form-section {
  width: 55%;
  background: #fff;
  padding: 50px 60px;
  display: flex;
  align-items: center;

  .form-wrapper {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;

    .form-header {
      margin-bottom: 40px;

      .form-title {
        font-size: 32px;
        font-weight: 700;
        font-style: oblique;
        color: #1a1a2e;
        margin: 0 0 20px 0;
        font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
        position: relative;
        display: inline-block;
        animation: titleGlow 3s ease-in-out infinite;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          bottom: -5px;
          width: 100%;
          height: 3px;
          background: linear-gradient(90deg, #ffffff,#57a9f2, #03a9f4, #0288d1);
          background-size: 200% 100%;
          animation: shimmer 2s linear infinite;
          border-radius: 13px;
        }

        span {
          min-width:36px;
          display: inline-block;
          animation: bounceIn 0.8s ease-out forwards;
          opacity: 0;
          animation-fill-mode: forwards;
          background: linear-gradient(135deg, #57a9f2 0%, #03a9f4 50%, #0288d1 100%);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: bounceIn 0.8s ease-out forwards, gradientMove 3s ease infinite;

          &:nth-child(1) { animation-delay: 0.1s, 0.1s; }
          &:nth-child(2) { animation-delay: 0.2s, 0.2s; }
          &:nth-child(3) { animation-delay: 0.3s, 0.3s; }
          &:nth-child(4) { animation-delay: 0.4s, 0.4s; }
        }
      }

      .form-desc {
        margin-top: 12px;
        font-size: 12px;
        color: #999;
        margin: 0;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        animation: fadeIn 1s ease-out 0.6s forwards;
        opacity: 0;
      }
    }

    @keyframes titleGlow {
      0%, 100% {
        text-shadow: 0 0 0 transparent;
      }
      50% {
        text-shadow: 0 0 20px rgba(87, 169, 242, 0.3);
      }
    }

    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }
      100% {
        background-position: 200% 0;
      }
    }

    @keyframes bounceIn {
      0% {
        opacity: 0;
        transform: translateY(-30px);
      }
      60% {
        transform: translateY(5px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes gradientMove {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    .login-form {
      .input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        background: #f8f9fa;
        border-radius: 12px;
        padding: 0 15px;
        transition: all 0.3s;

        &:focus-within {
          background: #fff;
          box-shadow: 0 0 0 2px rgba(87, 169, 242, 0.2);
        }

        .input-icon {
          width: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999;

          i {
            font-size: 18px;
          }
        }

        ::v-deep .el-input__inner {
          border: none;
          background: transparent;
          padding-left: 0;

          &::placeholder {
            color: #bbb;
          }
        }

        ::v-deep .el-input__wrapper {
          background: transparent;
          box-shadow: none;
          padding: 0;

          &:focus {
            box-shadow: none;
          }
        }
      }

      ::v-deep .el-form-item {
        margin-bottom: 24px;
      }

      .login-btn {
        width: 100%;
        height: 50px;
        border-radius: 12px;
        background: linear-gradient(135deg, #0288d1 0%, #03a9f4 100%);
        border: none;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 4px;
        transition: all 0.3s;
        box-shadow: 0 8px 20px rgba(26, 95, 180, 0.3);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 30px rgba(26, 95, 180, 0.4);
        }

        &:active {
          transform: translateY(0);
        }
      }

      .remember-checkbox {
        ::v-deep .el-checkbox__label {
          color: #999;
          font-size: 13px;
        }

        ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #57a9f2;
        }

        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #57a9f2;
          border-color: #57a9f2;
        }
      }
    }

    .form-footer {
      text-align: center;
      margin-top: 40px;
      padding-top: 30px;
      border-top: 1px solid #eee;

      .company-name {
        font-size: 12px;
        color: #ccc;
      }
    }
  }
}
</style>